import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/domains/companies/models';
import { ConnectionDetails } from 'src/app/domains/connectivity/models/connectivity.model';

@Component({
  selector: 'gdp-company-connectivity-details-main',
  templateUrl: './company-connectivity-details-main.component.html',
  styleUrls: ['./company-connectivity-details-main.component.scss']
})
export class CompanyConnectivityDetailsMainComponent implements OnInit {
  public currentTab = 'overview';
  public TAB_ICONS = {
    'overview': 'icon-small-info',
    'equipment': 'icon-big-phone'
  };
  public loading: boolean = false;
  public company: Company = null;
  public connectionID: number = null;
  public connection: ConnectionDetails;
  @ViewChild('nav', { static: false }) nav: NgbNav;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    if(this.router.getCurrentNavigation()?.extras?.state) {
      this.company = this.router.getCurrentNavigation().extras.state.company;
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.route.data.subscribe(
      (data: { resolved:{ connection: ConnectionDetails, company: Company}} ) => {
        this.loading = false;
        this.connection = data.resolved.connection;
        this.company = data.resolved.company
      }
    );
    if (this.router.url.includes('equipment')) {
      this.currentTab = 'equipment';
    }
  }

  public switchTab(tabId: string): void {
    this.nav.select(tabId);
    this.currentTab = tabId;
  }
}
